<!-- <div ng-if="$ctrl.length == 0" ? true : false></div> -->
<div *ngIf="source=='mobile'; else webBlock" >
</div>

<ng-template #webBlock>
  <mat-toolbar class="header-toolbar" *ngIf="!isMobileView">
    <mat-toolbar-row class="toolbar-row">
      <a routerLink="/" class="logo">
        <img src={{logoUrl}} alt="Best Offer Package" />
      </a>
<!-- If Current (user) Profile having status == 5 then all the navigation links will be 
disabled if any one click on it it will throw error stating that "please Upgrade Your plan" -->
    <div *ngIf="proStatus.status == 5; else widFlow">
        <nav mat-tab-nav-bar>
          <div class="alertWrapper">
            <span class="errMessage">{{errorMessage}}</span>
           </div>
          <ng-container *ngFor="let link of rootLinks">
            <a (click)="throwError($event)" class="link" mat-tab-link routerLinkActive #rla="routerLinkActive" [active]="rla.isActive"
            *ngxPermissionsOnly="link.userRole" [class.overflow]="isBadgeLink(link)">
            {{ link.text | borrowerLabel:'plural' }}
              <span *ngIf="isBadgeLink(link) | async" class="badge">
                {{totalBorrowersCount | async}}
              </span>
           </a> 
         </ng-container>  
        </nav>      
    </div>
  <!-- If Current (user) Profile having status other then 5 it will ridirect to provided links  -->
     <ng-template  #widFlow>
      <nav mat-tab-nav-bar>
        <ng-container *ngFor="let link of rootLinks">
          <a  class="link" mat-tab-link routerLinkActive #rla="routerLinkActive" [active]="rla.isActive"
            *ngxPermissionsOnly="link.userRole" [class.overflow]="isBadgeLink(link)" [routerLink]="link.url">
            {{ link.text | borrowerLabel:'plural' }}
            <span *ngIf="isBadgeLink(link) | async" class="badge">
              {{totalBorrowersCount | async}}
            </span>
          </a>          
        </ng-container>
      </nav>
     </ng-template>
     
        <div class="menu">
          <div *arbRealtorOnly>
            <a routerLink="/loan-officers2/invite2" mat-flat-button>
              <mat-icon svgIcon="add_user" class="button-icon add-user"></mat-icon>
              + Loan Officer
            </a>
          </div>
          <div *ngIf="proStatus.status == 5; else forOffer">
            <a (click)="throwError($event)" class="same-button" *arbRealtorOnly mat-flat-button>
              <span class="same-button-wrapper">
                <mat-icon class="button-icon" svgIcon="new_offer"></mat-icon>
                + Offer
              </span>
            </a>
          </div>
         <ng-template #forOffer>
          <div>
            <a class="same-button" routerLink="/offers/create" *arbRealtorOnly mat-flat-button>
              <span class="same-button-wrapper">
                <mat-icon class="button-icon" svgIcon="new_offer"></mat-icon>
                + Offer
              </span>
            </a>
          </div>
         </ng-template>
         
            <div *ngIf="proStatus.status == 5; else forRealtor"> 
              <a (click)="throwError($event)" class="same-button" *ngxPermissionsOnly="[userRoles.LoanOfficer, userRoles.Admin]" mat-flat-button>
              <span class="same-button-wrapper">
                <mat-icon svgIcon="add_user" class="add-user button-icon"></mat-icon>
                + Realtor
              </span>
              </a>
            </div>
            <ng-template #forRealtor>
              <div *ngIf="(userType == null ||userType > 1)"> 
                <a class="same-button" *ngxPermissionsOnly="[userRoles.LoanOfficer, userRoles.Admin]"
                routerLink="/realtors/invite" mat-flat-button>
                <span class="same-button-wrapper">
                  <mat-icon svgIcon="add_user" class="add-user button-icon"></mat-icon>
                  + Realtor
                </span>
                </a>
              </div>
            </ng-template>
            
          <div *arbAdminOnly>
            <a routerLink="/loan-officers/invite" mat-flat-button>
              <mat-icon svgIcon="add_user" class="button-icon add-user"></mat-icon>
              + Loan Officer
            </a>
          </div>
          <!-- <div *ngIf="freeLO">
            <a *arbRealtorOnly routerLink="/loan-officers2/invite2" mat-flat-button>
              <mat-icon svgIcon="add_user" class="button-icon add-user"></mat-icon>
              + Loan Officer
            </a>
          </div> -->
          <div *ngIf="proStatus.status == 5; else forBorrower">
            <a (click)="throwError($event)" class="same-button" 
            *ngxPermissionsOnly="[userRoles.Realtor, userRoles.LoanOfficer]" mat-flat-button>
            <span class="same-button-wrapper">
              <mat-icon svgIcon="add_user" class="button-icon add-user"></mat-icon>
              + {{ 'Borrower' | borrowerLabel }}
            </span>
           </a>
          </div>
         <ng-template #forBorrower>
          <div >
            <a class="same-button" routerLink="/borrowers/add"
            *ngxPermissionsOnly="[userRoles.Realtor, userRoles.LoanOfficer]" mat-flat-button>
            <span class="same-button-wrapper">
              <mat-icon svgIcon="add_user" class="button-icon add-user"></mat-icon>
              + {{ 'Borrower' | borrowerLabel }}
            </span>
           </a>
          </div>
         </ng-template>
         
        
          <arb-status-bar></arb-status-bar>
        </div>
    </mat-toolbar-row>
  </mat-toolbar>
  
  <mat-toolbar class="header-toolbar mobileView" *ngIf="isMobileView">
  
    <mat-toolbar-row class="toolbar-row">
  
      <a routerLink="/" class="logo">
        <img src={{logoUrl}} alt="Best Offer Package" />
      </a>
      <div class="occupy-space"></div>
  
      <arb-status-bar class="arb-status-bar"></arb-status-bar>
  
      <div class="menuIcon" #mobileMenu>&#9776;
      </div>
  
      <div class="mobile-header" *ngIf="isShowMenu">
        <ul class="mobile-menu">
         <div *ngIf="proStatus.status == 5; else forMobile">
          <nav mat-tab-nav-bar>
            <div class="alertWrapper">
              <span class="errMessage">{{errorMessage}}</span>
             </div>
            <ng-container *ngFor="let link of rootLinks">
              <li>
                <a (click)="throwError($event)" class="link" mat-tab-link routerLinkActive #rla="routerLinkActive" [active]="rla.isActive"
                  *ngxPermissionsOnly="link.userRole" [class.overflow]="isBadgeLink(link)">
                  {{ link.text | borrowerLabel:'plural' }}
                  <span *ngIf="isBadgeLink(link) | async" class="badge">
                    {{totalBorrowersCount$ | async}}
                  </span>
                </a>
              </li>
            </ng-container>
          </nav>
         </div>

         <ng-template #forMobile>
          <nav mat-tab-nav-bar>
            <div *ngIf="proStatus.status == 5;" class="alertWrapper">
              <span class="errMessage">{{errorMessage}} Custom Error</span>
             </div>
            <ng-container *ngFor="let link of rootLinks">
              <li>
                <a class="link" mat-tab-link routerLinkActive #rla="routerLinkActive" [active]="rla.isActive"
                  *ngxPermissionsOnly="link.userRole" [class.overflow]="isBadgeLink(link)" [routerLink]="link.url">
                  {{ link.text | borrowerLabel:'plural' }}
                  <span *ngIf="isBadgeLink(link) | async" class="badge">
                    {{totalBorrowersCount$ | async}}
                  </span>
                </a>
              </li>
            </ng-container>
          </nav>
         </ng-template>
         
          <div *ngIf="proStatus.status == 5; else forMobileOffer">
            <li *arbRealtorOnly>
              <a (click)="throwError($event)">+ Offer</a>
            </li>
          </div>
          <ng-template #forMobileOffer>
            <li *arbRealtorOnly>
              <a routerLink="/offers/create">+ Offer</a>
            </li>
          </ng-template>
          
          <!-- <div *ngIf="freeLO"> -->
            <div *ngIf="proStatus.status == 5; else forMobileRealtor">
            <li (click)="throwError($event)"  *ngxPermissionsOnly="[userRoles.Admin, userRoles.LoanOfficer]">
              <a  *ngIf="userType == null || userType > 1">
                + Realtor
              </a>
            </li>
          </div>
          <ng-template #forMobileRealtor>
            <li  *ngxPermissionsOnly="[userRoles.Admin, userRoles.LoanOfficer]">
              <a  *ngIf="userType == null || userType > 1" routerLink="/realtors/invite">
                + Realtor
              </a>
            </li>
          </ng-template>
          
          <!-- <div>
            <li *arbAdminOnly>
              <a *arbAdminOnly routerLink="/loan-officers/invite">
                + Loan Officer
              </a>
            </li>
          </div> -->
          <!-- <div *ngIf="freeLO">
            <li *arbRealtorOnly>
              <a *arbRealtorOnly routerLink="/loan-officers2/invite2">
    
                + Loan Officer
              </a>
            </li>
          </div> -->

          <div *arbRealtorOnly><li><a routerLink="/loan-officers2/invite2">+ Loan Officer</a></li></div>
          
          <div *ngIf="proStatus.status == 5; else forMobileBorrower">
            <li *ngxPermissionsOnly>
              <a class="" (click)="throwError($event)"  *ngxPermissionsOnly="[userRoles.Realtor, userRoles.LoanOfficer]"
                style="margin:0px">
                <span class="same-button-wrapper">
    
                  + {{ 'Borrower' | borrowerLabel }}
                </span>
              </a>
            </li>
          </div>
          <ng-template #forMobileBorrower>
            <li *ngxPermissionsOnly>
              <a class="" routerLink="/borrowers/add" *ngxPermissionsOnly="[userRoles.Realtor, userRoles.LoanOfficer]"
                style="margin:0px">
                <span class="same-button-wrapper">
    
                  + {{ 'Borrower' | borrowerLabel }}
                </span>
              </a>
            </li>
          </ng-template>
          
          
          
  
        </ul>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</ng-template>

